import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';
import { LoadingIndicator } from '../loading-indicator';

export type SignInButtonProps = {
  loading?: boolean;
  size: 'large';
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'size'>;

export const SignInButton = forwardRef(
  (
    { children, className, loading, disabled, size, ...props }: SignInButtonProps,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    const theme = useTheme();
    const classNames = classnames(className, 'airtame-sign-in-button', [
      `airtame-sign-in-button--${size}`,
    ]);

    const disabledOrLoading = disabled || loading;

    return (
      <button
        className={classNames}
        data-theme={theme}
        ref={ref}
        disabled={disabledOrLoading}
        {...props}
      >
        {children}
        {loading && (
          <span className="airtame-sign-in-button__loading-overlay">
            <LoadingIndicator className="airtame-sign-in-button__loading-indicator" />
          </span>
        )}
      </button>
    );
  }
);

SignInButton.displayName = 'SignInButton';
